import { TextFieldProps, ClickAwayListener } from '@mui/material'
import classNames from 'classnames'
import { TSuggest } from 'feature/registration/types'
import { ChangeEvent } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { TextField } from 'ui'
import { useDadataTextFieldProps } from 'widget/DadataSelectInput/hooks/useDadataTextFieldProps'
import { useDadataMultiSelectLogic } from 'widget/DadataSelectInput/hooks/useDadataMultiSelectLogic'
import { DadataSelectedField } from '../DadataSelectedField/DadataSelectedField'
import { DadataMultiSelectAdornment } from '../DadataMultiSelectAdornment'
import { DadataMultiSelectList } from '../DadataMultiSelectList/DadataMultiSelectList'

import style from './DadataMultiSelect.module.scss'
import baseStyle from 'widget/DadataSelectInput/DadataSelectInput.module.scss'

type DadataMultiSelectProps = {
  name: string
  inputProps: TextFieldProps
  className?: string
}

export function DadataMultiSelect({
  name,
  inputProps,
  className,
}: DadataMultiSelectProps) {
  const { control } = useFormContext()
  const { computedTextFieldProps, inputPropsInputProps } =
    useDadataTextFieldProps(inputProps)

  const {
    isInputVisible,
    inputValue,
    inputError,
    isDadataSelectVisible,
    isLoadingSuggest,
    suggests,
    selectInputRef,
    handleChange,
    selectHandler,
    onClickAwayHandler,
    onFocus,
    removeValue,
    handleCancel,
    openInput,
  } = useDadataMultiSelectLogic({ name })

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { value = [], onChange } = field
        const error = fieldState.error
        const selectedValues = Array.isArray(value) ? (value as TSuggest[]) : []
        const hasSelectedValues = selectedValues.length > 0

        return (
          <ClickAwayListener onClickAway={onClickAwayHandler}>
            <div className={classNames(baseStyle.select, style.multiSelect)}>
              {selectedValues.map((val: TSuggest) => (
                <DadataSelectedField
                  addressValue={val}
                  inputProps={inputProps}
                  removeValue={() => removeValue(val, selectedValues, onChange)}
                  key={`${val.address}-${val.fiasId}`}
                />
              ))}
              {!isInputVisible && (
                <button
                  type='button'
                  className={style.addAddressLink}
                  onClick={openInput}
                >
                  + Добавить адрес
                </button>
              )}
              {isInputVisible && (
                <div className={style.inputWrapper}>
                  <TextField
                    autoComplete='off'
                    className={classNames(
                      baseStyle.selectInput,
                      className && className,
                    )}
                    inputRef={selectInputRef}
                    onFocus={onFocus}
                    onChange={e =>
                      handleChange(e as ChangeEvent<HTMLInputElement>)
                    }
                    value={inputValue}
                    error={!!error || !!inputError}
                    helperText={error?.message ?? inputError}
                    InputProps={{
                      ...inputPropsInputProps,
                      endAdornment: (
                        <div className={style.inputActions}>
                          <DadataMultiSelectAdornment
                            hasSelectedValues={hasSelectedValues}
                            handleCancel={handleCancel}
                          />
                        </div>
                      ),
                    }}
                    {...computedTextFieldProps}
                  />
                  <DadataMultiSelectList
                    isDadataSelectVisible={isDadataSelectVisible}
                    suggests={suggests}
                    selectHandler={item => selectHandler(item, onChange)}
                    isLoadingSuggest={isLoadingSuggest}
                  />
                </div>
              )}
            </div>
          </ClickAwayListener>
        )
      }}
    />
  )
}
